module.exports = __webpack_public_path__ + "img/webinars-form__1920.f6c4bf6.jpg";